import * as PreferenceAction from '../actions/PreferenceAction';
import { ContentFeatureDefinition } from '../types/epub';
import { defaultLineHeight } from '../constants';

export interface PreferenceState {
  readonly enableGeneralRuby: boolean;
  readonly fontSize: number; // %値, デフォルトは"100"
  readonly fontFamily: PreferenceAction.FontFamily;
  readonly lineHeight: number; // line-heightに指定する値, デフォルトは"1.75"
  readonly padding: number; // bodyのpaddingに指定する値, デフォルトは"1",単位はem
  readonly colorScheme: PreferenceAction.ColorScheme;
  readonly customPageColorIndex: PreferenceAction.CustomPageColorIndex;
  readonly contentFeatureFlags: { [featureID: string]: boolean };
  readonly enableColoringOfPages: boolean;
  readonly userName: string;
  readonly ttsTracking: boolean;
}

export const initPreferenceState = (): PreferenceState => ({
  enableGeneralRuby: false,
  fontSize: 100,
  fontFamily: PreferenceAction.FontFamily.Textbook,
  lineHeight: defaultLineHeight,
  padding: 1,
  colorScheme: PreferenceAction.ColorScheme.Scheme1,
  contentFeatureFlags: {},
  enableColoringOfPages: false,
  customPageColorIndex: {
    backgroundColorIndex: 0,
    textColorIndex: 9,
  },
  userName: 'ゲスト',
  ttsTracking: true,
});

function setContentFeatureFlag(state: PreferenceState, featureID: string, enabled: boolean) {
  if (state.contentFeatureFlags[featureID] === enabled) {
    return state;
  }
  return {
    ...state,
    contentFeatureFlags: { ...state.contentFeatureFlags, [featureID]: enabled },
  };
}

export const initContentFeatureFlags = (
  state: PreferenceState,
  featureDefinitions: ReadonlyArray<ContentFeatureDefinition>,
): PreferenceState => {
  const contentFeatureFlags: { [featureID: string]: boolean } = {};
  for (const definition of featureDefinitions) {
    contentFeatureFlags[definition.id] = definition.defaultValue;
  }

  return { ...state, contentFeatureFlags };
};

export const preference = (
  state: PreferenceState,
  action: PreferenceAction.PreferenceAction,
): PreferenceState => {
  switch (action.type) {
    case PreferenceAction.PREF_SET_GENERAL_RUBY:
      return { ...state, enableGeneralRuby: action.visible };
    case PreferenceAction.PREF_SET_FONT_SIZE:
      return { ...state, fontSize: action.size };
    case PreferenceAction.PREF_SET_FONT_FAMILY:
      return { ...state, fontFamily: action.family };
    case PreferenceAction.PREF_SET_LINE_HEIGHT:
      return { ...state, lineHeight: action.size * defaultLineHeight };
    case PreferenceAction.PREF_SET_PADDING:
      return { ...state, padding: action.size };
    case PreferenceAction.PREF_SET_COLOR_SCHEME:
      return { ...state, colorScheme: action.colorScheme };
    case PreferenceAction.PREF_SET_ENABLE_COLORING_OF_PAGES:
      return { ...state, enableColoringOfPages: action.enableColoringOfPages };
    case PreferenceAction.PREF_SET_CUSTOM_PAGE_COLOR_INDEX:
      return { ...state, customPageColorIndex: action.customPageColorIndex };
    case PreferenceAction.PREF_SET_CONTENT_FEATURE_FLAG:
      return setContentFeatureFlag(state, action.featureID, action.enabled);
    case PreferenceAction.PREF_SET_USER_NAME:
      return { ...state, userName: action.userName };
    case PreferenceAction.PREF_SET_TTS_TRACKING:
      return { ...state, ttsTracking: action.ttsTracking };
  }
};
